import React from 'react'

const PaymentForm = () => {
  return (
    <div>
        {/* <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfDGXsHPwzXjyQ0AKNY2igU-ESTDGsiVtdUetpoZP1Hj2ra_Q/viewform?embedded=true" width="640" height="1503" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe> */}
        <p className='text-md text-center mt-3'>Coming Soon</p>
    </div>
  )
}

export default PaymentForm